import { useTranslation } from 'react-i18next';
import Icon from '../../../../components/common/Icon';
import { ReactComponent as InfoIcon } from '../../../../icons/info-circle-solid.svg';

const SearchSongsNotFound = ({ searchQuery }) => {
  const { t } = useTranslation();

  return (
    <div className="not-found">
      <Icon icon={<InfoIcon />} />
      <p>{t('publicSongs.notFound', { query: searchQuery })}</p>
      <p className="text-color">
        <strong>{t('publicSongs.beFirst')}</strong>
      </p>
    </div>
  );
};

export default SearchSongsNotFound;
